/**
 * MoonwellSupplyStrategy call builder.
 *
 * InitParams (Solidity, V2): (address underlying, address mToken, uint256 supplyAmount,
 * uint256 minRedeemAmount, bool isNativeEthMarket)
 *
 * `isNativeEthMarket` — true when the mToken is Moonwell's native-ETH (mWETH)
 * market, whose redeem returns raw ETH the strategy must wrap back to WETH.
 * false for ERC-20 markets (USDC). V2 beta added this field; encoding the old
 * 4-field payload makes the clone's `initialize` abi.decode revert with empty
 * data (vnet e2e finding, issues #411-#414).
 */

import type { Address, Hex } from "viem";
import { encodeAbiParameters, encodeFunctionData } from "viem";
import { ERC20_ABI, BASE_STRATEGY_ABI } from "../lib/abis.js";
import type { BatchCall } from "../lib/batch.js";

export function buildInitData(
  underlying: Address,
  mToken: Address,
  supplyAmount: bigint,
  minRedeemAmount: bigint,
  isNativeEthMarket: boolean,
): Hex {
  return encodeAbiParameters(
    [
      { type: "address" },
      { type: "address" },
      { type: "uint256" },
      { type: "uint256" },
      { type: "bool" },
    ],
    [underlying, mToken, supplyAmount, minRedeemAmount, isNativeEthMarket],
  );
}

export function buildExecuteCalls(
  clone: Address,
  underlying: Address,
  supplyAmount: bigint,
): BatchCall[] {
  return [
    {
      target: underlying,
      data: encodeFunctionData({
        abi: ERC20_ABI,
        functionName: "approve",
        args: [clone, supplyAmount],
      }),
      value: 0n,
    },
    {
      target: clone,
      data: encodeFunctionData({
        abi: BASE_STRATEGY_ABI,
        functionName: "execute",
      }),
      value: 0n,
    },
  ];
}

export function buildSettleCalls(clone: Address): BatchCall[] {
  return [
    {
      target: clone,
      data: encodeFunctionData({
        abi: BASE_STRATEGY_ABI,
        functionName: "settle",
      }),
      value: 0n,
    },
  ];
}
